import { Main as BaseMain } from './main';
import { Page as BasePage, SideBar, SideBarFooter, SideBarHeader, SideBarMain } from './page';

export const Page = Object.assign(BasePage, {
  Main: BaseMain,
  SideBar: Object.assign(SideBar, { Footer: SideBarFooter, Header: SideBarHeader, Main: SideBarMain }),
});
